import React from 'react';
import { useLocation } from 'react-router-dom';
import LegacyLogin from './LegacyLogin';
import PostExAuthLogin from './PostExAuthLogin';

const Login = ({ isForgetMode = false }) => {
  const location = useLocation();
  const useLegacy = isForgetMode || location.pathname === '/auth/forgot';

  if (useLegacy) {
    return <LegacyLogin isForgetMode={isForgetMode} />;
  }

  return <PostExAuthLogin />;
};

export default Login;
